import { useAsyncExecutor } from "async-executor-hook";
import { Paginator } from "primereact/paginator";
import { useState } from "react";

import {
  BodyContainerTableCommon,
  ContainerConfigurateCommon,
  ContainerGridColumnsTableCommon,
  ContainerScrollCommon,
  TableHeaderCommonResponsive,
} from "../../common/components/TableResponsive";
import { getErrorValueResponse } from "../../common/error/Error";
import IconWarning from "../../images/icon_warning.svg";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { LOADING_SIZE_RUCS } from "../../utils/valueStaticConstants";
import { PaginatorModal } from "../CreditMethod/CreditMethodStyles";
import Modal from "../Modal/Modal";
import PaymentLoader from "../PaymentLoader/PaymentLoader";
import AdditionalRucsModalSearch from "./AdditionalRucsModalSearch";
import {
  DivBodyRuc,
  DivHeaderRuc,
  RucsButton,
  RucsContainer,
} from "./AdditionalRucsModalStyles";
import { ConvertResponseCreditBillableRucs } from "./ConvertResponseCreditBillableRucs";

function AdditionalRucsModal(props) {
  const {
    toggleModal,
    updateOtherRucInfo,
    showModalTercero,
    hideOtherRucModal,
    closeModalRuc,
    setShowModalErrorAdditionalRucs,
    setShowModalMessageAdditionalRucs,
    updateShowRucModal,
    setShowModalOthersRucGV,
    setShowModalMessageOthersRucGV,
    updateShowOtherRucModal,
  } = props;

  const [selectedRuc, updateSelectedRuc] = useState("");

  const getCreditThirdbillableRucs = useAsyncExecutor(
    (params: any) => {
      const paramsGeneral = {
        page_size: 5,
        page: params.page ?? 1,
      };
      updateSelectedRuc("");
      if (params.data || params.dataSearch) {
        const { data } = params;
        if (params.dataSearch) {
          if (params.dataSearch.type_option === "r_s") {
            const paramsUpdateRS = {
              ...paramsGeneral,
              billable_ruc_name: params.dataSearch.billable_ruc_name,
            };
            return networkBackendRequest(
              `/billable-rucs/`,
              HTTP_METHODS.GET,
              paramsUpdateRS
            )
              .then((response) => response.json())
              .then(ConvertResponseCreditBillableRucs);
          } else if (params.dataSearch.type_option === "ruc") {
            const paramsUpdateRuc = {
              ...paramsGeneral,
              billable_ruc: params.dataSearch.billable_ruc,
            };
            return networkBackendRequest(
              `/billable-rucs/`,
              HTTP_METHODS.GET,
              paramsUpdateRuc
            )
              .then((response) => response.json())
              .then(ConvertResponseCreditBillableRucs);
          }
        }

        if (data.type_option === "r_s") {
          const paramsRS = {
            ...paramsGeneral,
            billable_ruc_name: data.billable_ruc_name,
          };
          return networkBackendRequest(
            `/billable-rucs/`,
            HTTP_METHODS.GET,
            paramsRS
          )
            .then((response) => response.json())
            .then(ConvertResponseCreditBillableRucs);
        }

        if (data.type_option === "ruc") {
          const paramsRuc = {
            ...paramsGeneral,
            billable_ruc: data.billable_ruc,
          };
          return networkBackendRequest(
            `/billable-rucs/`,
            HTTP_METHODS.GET,
            paramsRuc
          )
            .then((response) => response.json())
            .then(ConvertResponseCreditBillableRucs);
        }
      } else {
        const paramsRucInitial = {
          ...paramsGeneral,
          billable_ruc_name: "",
        };
        return networkBackendRequest(
          `/billable-rucs/`,
          HTTP_METHODS.GET,
          paramsRucInitial
        )
          .then((response) => response.json())
          .then(ConvertResponseCreditBillableRucs);
      }
    },
    {
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        if (setShowModalMessageAdditionalRucs) {
          setShowModalMessageAdditionalRucs(errorMessage);
          setShowModalErrorAdditionalRucs(true);
        } else {
          setShowModalMessageOthersRucGV(errorMessage);
          setShowModalOthersRucGV(true);
        }
        if (updateShowRucModal) {
          updateShowRucModal(false);
        } else {
          updateShowOtherRucModal(false);
        }
      },
    }
  );

  const [dataSearch, setDataSearch] = useState();
  const [isChecked, setIsChecked] = useState(false);
  const GRID_TEMPLATE_COLUMNS = "4rem 1.5fr 1fr";
  return (
    <Modal onOutsideClick={hideOtherRucModal || closeModalRuc}>
      <RucsContainer width="90rem">
        <h1 className="spacing">RUC FACTURABLE OTROS</h1>
        <AdditionalRucsModalSearch
          getCreditThirdbillableRucs={getCreditThirdbillableRucs}
          setDataSearch={setDataSearch}
        />
        <div
          style={{ width: "100%", marginLeft: "4.2rem", marginRight: "4.2rem" }}
        >
          {getCreditThirdbillableRucs.status === "PROCESSING" && (
            <div
              style={{
                marginRight: "2rem",
                marginLeft: "2rem",
                background: "#F6F6FD",
              }}
            >
              <PaymentLoader numItems={LOADING_SIZE_RUCS} />
            </div>
          )}
          <ContainerScrollCommon>
            <ContainerConfigurateCommon>
              <ContainerGridColumnsTableCommon
                gridTemplateColumns={GRID_TEMPLATE_COLUMNS}
              >
                {getCreditThirdbillableRucs.isSuccess &&
                  getCreditThirdbillableRucs.data.rucs.length > 0 && (
                    <TableHeaderCommonResponsive className="item-container">
                      <div
                        className="main-info-header"
                        style={{ marginLeft: "2rem" }}
                      ></div>
                      <DivHeaderRuc marginLeft="1.5rem">
                        RUC/RAZÓN SOCIAL
                      </DivHeaderRuc>
                      <DivHeaderRuc>DIRECCIÓN FISCAL</DivHeaderRuc>
                    </TableHeaderCommonResponsive>
                  )}
                <div
                  style={{
                    overflowY: "scroll",
                    maxHeight: "60vh",
                    background: "#F6F6FD",
                  }}
                  className="scroll"
                >
                  {getCreditThirdbillableRucs.isSuccess &&
                    getCreditThirdbillableRucs.data.rucs.map((ruc, id) => {
                      return (
                        <div key={id}>
                          <BodyContainerTableCommon
                            className="item-container"
                            height="auto"
                            padding="1.8rem 1.5rem"
                          >
                            <div
                              className="attribute"
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                              }}
                            >
                              <div className="titles"></div>
                              <input
                                style={{ cursor: "pointer" }}
                                className="checkInvoice clickable-element"
                                type="checkbox"
                                checked={ruc.id === selectedRuc && isChecked}
                                onChange={(e) => {
                                  updateSelectedRuc(ruc.id);
                                  setIsChecked(e.target.checked);
                                }}
                              />
                            </div>
                            <DivBodyRuc className="attribute">
                              <div className="titles">RUC/RAZÓN SOCIAL</div>
                              <DivBodyRuc className="left-align">
                                <div className="ruc-id">{ruc.id}</div>
                                <div>{ruc.name}</div>
                              </DivBodyRuc>
                            </DivBodyRuc>
                            <DivBodyRuc className="attribute">
                              <div className="titles">DIRECCIÓN FISCAL</div>
                              <DivBodyRuc className="left-align">
                                <div>{ruc.address}</div>
                                <div className="ruc-id">{ruc.district}</div>
                              </DivBodyRuc>
                            </DivBodyRuc>
                          </BodyContainerTableCommon>
                        </div>
                      );
                    })}
                </div>
              </ContainerGridColumnsTableCommon>
            </ContainerConfigurateCommon>
          </ContainerScrollCommon>

          <>
            {getCreditThirdbillableRucs.isSuccess &&
            getCreditThirdbillableRucs.data.rucs.length === 0 ? (
              <div className="warning-message alert-spacing">
                <img src={IconWarning} alt="warning" />
                <p>
                  No se encontró RUC o razón social ingresada. Favor de
                  comunicarse con el equipo de soporte TalmaClick para que sea
                  agregada.
                </p>
              </div>
            ) : (
              <>
                {!getCreditThirdbillableRucs.isLoading && (
                  <div className="warning-message">
                    <img src={IconWarning} alt="warning" />
                    <p>
                      Necesita adjuntar un documento para poder autorizar la
                      facturación con un RUC de terceros.
                    </p>
                  </div>
                )}
              </>
            )}

            {getCreditThirdbillableRucs.isSuccess &&
              getCreditThirdbillableRucs.data.rucs.length > 0 && (
                <div className="right-align spacing">
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <PaginatorModal>
                      <Paginator
                        className="class-paginator-color-f"
                        first={
                          (getCreditThirdbillableRucs.data.page - 1) *
                          getCreditThirdbillableRucs.data.page_size
                        }
                        rows={getCreditThirdbillableRucs.data.page_size}
                        totalRecords={getCreditThirdbillableRucs.data.count}
                        onPageChange={(e) => {
                          const targetPage =
                            e.first / getCreditThirdbillableRucs.data.page_size;
                          getCreditThirdbillableRucs.execute({
                            page: targetPage + 1,
                            dataSearch,
                          });
                        }}
                      />
                    </PaginatorModal>
                  </div>
                </div>
              )}
          </>
          {!getCreditThirdbillableRucs.isLoading && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <RucsButton
                onClick={() => {
                  updateOtherRucInfo(
                    getCreditThirdbillableRucs.isSuccess &&
                      getCreditThirdbillableRucs.data.rucs.find(
                        (e) => e.id === selectedRuc
                      )
                  );
                  toggleModal(true);
                  showModalTercero();
                }}
                disabled={
                  (getCreditThirdbillableRucs.isSuccess &&
                    getCreditThirdbillableRucs.data.rucs.length === 0) ||
                  !selectedRuc ||
                  !isChecked
                }
              >
                Adjuntar documento
              </RucsButton>
            </div>
          )}
        </div>
      </RucsContainer>
    </Modal>
  );
}

export default AdditionalRucsModal;
